import { useSelector } from "react-redux";
import Cookie from "utils/cookie";

const useSubscriptionGuard = () => {
  const userProfile = useSelector((state) => state.user.userProfile);

  // Try Redux state first, fall back to cookie
  const subscription =
    userProfile?.organization?.subscription ||
    Cookie.getParsedUser()?.subscription ||
    {};

  const isFree = subscription.type === "FREE" || !subscription.type;
  const canCreate = !isFree;

  return { isFree, canCreate, subscription };
};

export default useSubscriptionGuard;
